import moment from 'moment'
import { getDateUrlParameter } from 'cogsworth/utils/filters'

export const getLookupStartLimit = () => {
  const startLimit = getDateUrlParameter(window.location.search, 'limit[start]')
  if (startLimit) {
    return moment(startLimit).utc().add(1, 'minute')
  }

  return moment().utc().add(1, 'minute')
}
